import { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { Cookie } from "lucide-react";
import { ease } from "./Primitives";
import { useT } from "@/lib/i18n";

export const CONSENT_KEY = "lm_cookie_consent";

export const openCookiePrefs = () => window.dispatchEvent(new Event("lm-cookie-open"));

export const CookieBanner = () => {
  const t = useT().cookies;
  const [open, setOpen] = useState(() => !localStorage.getItem(CONSENT_KEY));

  useEffect(() => {
    const on = () => setOpen(true);
    window.addEventListener("lm-cookie-open", on);
    return () => window.removeEventListener("lm-cookie-open", on);
  }, []);

  const choose = (v) => {
    localStorage.setItem(CONSENT_KEY, v);
    if (typeof window.gtag === "function") {
      window.gtag("consent", "update", { analytics_storage: v === "granted" ? "granted" : "denied" });
    }
    setOpen(false);
  };

  return (
    <AnimatePresence>
      {open && (
        <motion.div role="dialog" aria-label={t.title} data-testid="cookie-banner"
          initial={{ opacity: 0, y: 40 }} animate={{ opacity: 1, y: 0 }} exit={{ opacity: 0, y: 40 }} transition={{ duration: 0.5, ease }}
          className="fixed z-[70] bottom-4 left-4 right-4 md:right-auto md:max-w-md rounded-[24px] border border-[var(--line)] bg-[#0c0a09]/95 backdrop-blur-xl p-6 shadow-2xl text-[#f5f5f0] font-['Plus_Jakarta_Sans',sans-serif]">
          <div className="flex items-center gap-3">
            <Cookie size={20} className="text-[var(--gold)]" />
            <p className="font-display text-2xl">{t.title}</p>
          </div>
          <p className="mt-3 text-sm text-stone-300 leading-relaxed">{t.text}</p>
          <a href="/privacy#cookie" data-testid="cookie-policy-link" className="mt-2 inline-block text-sm text-[var(--gold)] underline underline-offset-4">{t.policy}</a>
          <div className="mt-5 flex gap-3">
            <button onClick={() => choose("denied")} data-testid="cookie-reject-btn" className="btn-ghost flex-1 justify-center !py-2.5 text-sm">{t.reject}</button>
            <button onClick={() => choose("granted")} data-testid="cookie-accept-btn" className="btn-gold flex-1 justify-center !py-2.5 text-sm">{t.accept}</button>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
